// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"d225e018","347":"53f7b9ea"}[chunkId] + ".chunk.css";
};